import { atom } from "recoil";
import { v4 } from "uuid";

export const TranslateState = atom<any>({
  key: v4(),
  default: {
    data: null,
  },
});
